<template>
  <div class="info-row__container">
    <p class="info-row__label">{{ label }}</p>
    <p class="info-row__value">
      <slot>{{ value }}</slot>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.info-row {
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__label {
    font-size: 14px;
    font-weight: 400;
    color: #717680;
    padding: 0;
    margin: 0 0 4px;
  }

  &__value {
    font-size: 16px;
    font-weight: 500;
    padding: 0;
    margin: 0;
  }
}
</style>